export default class extends HTMLElement {
  connectedCallback () {
    const form = this.querySelector('form')
    const success = this.querySelector('[data-newsletter-success]')
    if (!form || !success) return

    form.addEventListener('submit', (e) => {
      e.preventDefault()
      const email = this.querySelector('input[type="email"]')
      if (!email || !email.value) return

      form.classList.add('hidden')
      success.classList.remove('hidden')
      success.classList.add('flex')
    })
  }
}
